import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useAuth } from "../context/AuthContext";

const SECTIONS = [
  {
    title: "1. Ownership",
    body: "All content within the UnCloned® Ads Lookbook — including creatives, copywriting, categories, thumbnails, video files, hooks, angles, offers, and all associated metadata — is the exclusive property of UnCloned® Media. All rights reserved."
  },
  {
    title: "2. License to view",
    body: "Access to this library is granted on a personal, non-exclusive, non-transferable, revocable basis for the sole purpose of drawing inspiration for your own original marketing campaigns. No other rights are granted."
  },
  {
    title: "3. Prohibited use",
    body: "You may not (a) reproduce, redistribute, resell, publish, or publicly display any content from the library, (b) share your login credentials with any other person, (c) scrape, download in bulk, mirror, or archive the library, (d) copy the design, structure, code, or workflow of this platform to build a competing product, (e) remove, alter, or obscure any copyright or attribution notices."
  },
  {
    title: "4. Access codes & invitations",
    body: "Access codes and invitations may be issued for a specific event, purchase, or workshop cohort. Codes have a defined capacity and expiration date. UnCloned® Media reserves the right to disable any account or revoke any access code at any time, with or without notice, for any reason including violation of these terms."
  },
  {
    title: "5. Downloads",
    body: "Downloadable variants (Feed, Stories, Reels, thumbnails) are provided as inspiration reference only. Recreating, republishing, or using any downloaded file directly in your own advertising is strictly prohibited without a separate written license from UnCloned® Media."
  },
  {
    title: "6. Trademark",
    body: "\"UnCloned®\", the UnCloned® mark, and all associated logos and branding are registered trademarks of UnCloned® Media. Unauthorized use is prohibited."
  },
  {
    title: "7. Enforcement",
    body: "UnCloned® Media may pursue any and all remedies available under law, including injunctive relief and monetary damages, against any person or entity that violates these terms."
  },
  {
    title: "8. Changes",
    body: "These terms may be updated from time to time. Continued use of the library after any change constitutes acceptance of the updated terms."
  },
  {
    title: "9. Contact",
    body: "For licensing inquiries, questions, or to report unauthorized use of this content, contact hello@unclonedmarketing.com."
  }
];

export default function Terms() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {user && <Navbar />}
      <main className="max-w-3xl w-full mx-auto px-6 py-14 flex-1" data-testid="terms-page">
        <div className="fade-up">
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-[#0FFFE2]">Legal</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl text-[#000000] tracking-tight mt-2">Terms of Use &amp; Copyright</h1>
          <p className="text-sm text-gray-500 mt-3">Effective January 1, 2026 · © 2026 UnCloned® Media. All rights reserved.</p>
        </div>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid={`terms-section-${s.title.split(" ")[0].replace('.', '')}`}>
              <h2 className="font-display font-black text-lg text-[#000000]">{s.title}</h2>
              <p className="text-sm text-gray-600 mt-2 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
        <div className="mt-14 border-t border-gray-200 pt-6 text-xs text-gray-500">
          UnCloned® Media · hello@unclonedmarketing.com · © 2026 UnCloned® Media
        </div>
      </main>
      <Footer />
    </div>
  );
}
